import { AudioClip } from 'js/types';

export function toMilliseconds(seconds: number): number {
  return seconds * 1000;
}

export function toSeconds(milliseconds: number): number {
  return milliseconds / 1000;
}

export function clipPlaybackDurationSeconds(clip: AudioClip): number {
  return clip.instanceDuration ?? clip.duration ?? 0;
}
